import { render, staticRenderFns } from "./update-personal-data.vue?vue&type=template&id=51b0b55b"
import script from "./update-personal-data.vue?vue&type=script&lang=js"
export * from "./update-personal-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports